export function useBackgroundCheckAPI() {
  const { errors, request } = useRequestV2();
  
  async function getBackgroundCheckCertificate() {
    const url = 'V3/BackgroundCheck/Certificate';
  
    return await request<string>(url);
  }

  return {
    errors,
    getBackgroundCheckCertificate
  };
}
